<div id="toggler" class="align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="row">
        <div class="col-2 col-lg-1 ps-4 float-start align-content-center">
            <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>
        <div class="col-4 col-lg-3 user-select-auto">{{ material.materialNr.value }}<br />{{ material.descTxt }}</div>
        <div class="d-none d-lg-block col-lg-4 user-select-auto">
            <ng-container *ngIf="material.longText.length > 0">
                <div *ngFor="let line of material.longText">{{ line }}</div>
            </ng-container>
            <ng-container *ngIf="displayOptions.displayTs">
                <div>
                    <strong translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_TS"></strong>
                    {{ material.tsPercentage }}%/{{ material.tsPercentageCounter }}
                </div>
            </ng-container>
            <ng-container *ngIf="displayOptions.displayNdf" class="ms-4">
                <div>
                    <strong translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_NDF"></strong>
                    {{ material.ndfQuote }}%/{{ material.ndfCounter }}
                </div>
            </ng-container>
        </div>
        <div class="col-4 col-lg-3">
            <pace-core-number-input
                id="quantity"
                [parentForm]="parentForm"
                name="quantity"
                [(model)]="material.quantity"
                [ariaLabel]="'MATERIAL_ORDER_NUMBER_QUANTITY_ARIA_LABEL' | translate"
            ></pace-core-number-input>
        </div>
        <div class="col-2 col-lg-1">
            <button class="btn btn-warning float-end" type="button" (click)="deleteMaterial.emit()">
                <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
        </div>
    </div>
</div>
<div *ngIf="!isCollapsed" class="py-3">
    <div class="row">
        <div class="col-12 col-lg-6">
            <div class="d-lg-none row align-items-center">
                <label class="col col-form-label" translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_INFO"></label>
                <div class="col">
                    <ng-container *ngIf="material.longText.length > 0">
                        <div *ngFor="let line of material.longText">{{ line }}</div>
                    </ng-container>
                    <ng-container *ngIf="displayOptions.displayTs">
                        <div>
                            <strong translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_TS"></strong>
                            {{ material.tsPercentage }}%/{{ material.tsPercentageCounter }}
                        </div>
                    </ng-container>
                    <ng-container *ngIf="displayOptions.displayNdf">
                        <div>
                            <strong translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_NDF"></strong>
                            {{ material.ndfQuote }}%/{{ material.ndfCounter }}
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="displayOptions.displayStorageLocation" class="row align-items-center">
                <label
                    class="col col-form-label"
                    translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_STORAGE_LOCATION"
                ></label>
                <div class="col-6">
                    {{ material.storageLoc.value }}<br />
                    {{ material.storageLocDesc }}
                </div>
            </div>
            <div *ngIf="displayOptions.displayAvailable" class="row align-items-center">
                <label class="col col-form-label" *ngIf="displayOptions.displayAvailable">
                    <span translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_AVAILABLE"></span>&nbsp;
                    <span translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_UNIT"></span>
                </label>
                <div class="col-6">{{ material.available }} {{ material.extUnit }}</div>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div *ngIf="displayOptions.displayCustomerPrice" class="row align-items-center">
                <label class="col col-form-label" translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_PRICE"></label>
                <div class="col-6">{{ material.customerPrice }}{{ material.customerCurrency }}</div>
            </div>
            <div *ngIf="displayOptions.displayRepairPrice" class="row align-items-center">
                <label class="col col-form-label" translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_REPAIR_PRICE"></label>
                <div class="col-6">{{ material.repairPrice }}{{ material.repairCurrency }}</div>
            </div>
        </div>
    </div>
</div>
